var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidsbabyunit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "katman 2",
    viewBox: "0 0 13.58 11.43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.62,11.19H.97c-.56,0-.91-.6-.62-1.08L6.17.59c.28-.46.96-.46,1.24,0l5.82,9.52c.29.47-.06,1.08-.62,1.08Z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: ".48px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.43,10.04H2.15c-.26,0-.42-.27-.29-.49L6.5,2.09c.13-.21.44-.21.57,0l4.64,7.47c.13.22-.03.49-.29.49Z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: ".48px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsbabyunit);
export default __webpack_public_path__ + "static/media/KIDSBABYUNIT.97a30245b8a44c529dd00eeb454121c5.svg";
export { ForwardRef as ReactComponent };